import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './StartTestButton.css';

const StartTestButton = () => {
  return (
    <section className="start-test-section">
      <div className="start-test-container">
        <h3>¿Listo para conocer tu estado emocional?</h3>
        <p>Descubre cómo te encuentras realmente y recibe recomendaciones personalizadas</p>
        
        <motion.div 
          className="bottom-cta-button-container"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <Link to="/area-selection" className="bottom-cta-button pulse-animation">
            Evalúa tu bienestar en solo 3 minutos
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default StartTestButton;
